import {
  postData,
} from 'src/services/RestApi';

export const apiCreate = async (values) => {
  const queryParam = {
    moduleType: values.moduleType,
    sourceId: values.sourceId,
    userId: values.userId,
    reason: values.reason,
  };
  return await postData('api/ticket/create', queryParam);
};

export const apiUpdate = async (values) => {
  const queryParam = {
    moduleType: values.moduleType,
    ticketId: values.ticketId,
    status: values.status,
    reason: values.reason,
  };
  return await postData('api/ticket/update', queryParam);
};

export const apiDelete = async (values) => {
  const queryParam = {
    moduleType: values.moduleType,
    ticketId: values.ticketId,
    userId: values.userId,
  };
  return await postData('api/ticket/delete', queryParam);
};